import request from '../request'

export const getSubjects = (curriculumId, filter) =>
  request.post(`/assessment/${curriculumId}/subject/list`, { filter }).then((res) => res)

export const getSubjectsFromClasses = (curriculumId) =>
  request.post(`/assessment/${curriculumId}/subject/list/from-classes`).then((res) => res)

export const getSubjectsSkipLimit = (curriculumId, skip = 0, limit = 5, filter) =>
  request
    .post(`/assessment/${curriculumId}/subject/list/skip/${skip}/limit/${limit}`, { filter })
    .then((res) => res)

export const getSubjectById = (curriculumId, id) =>
  request.get(`/assessment/${curriculumId}/subject/${id}`).then((res) => res)

export const createSubject = (curriculumId, data) =>
  request.post(`/assessment/${curriculumId}/subject`, data).then((res) => res)

export const cloneSubject = (curriculumId, id) =>
  request.post(`/assessment/${curriculumId}/subject/${id}/clone`).then((res) => res)

export const updateSubject = (curriculumId, id, data) =>
  request.put(`/assessment/${curriculumId}/subject/${id}`, data).then((res) => res)

export const archiveSubject = (curriculumId, id) =>
  request.delete(`/assessment/${curriculumId}/subject/${id}/archive`).then((res) => res)

export const deleteSubject = (curriculumId, id) =>
  request.delete(`/assessment/${curriculumId}/subject/${id}`).then((res) => res)

export const batchUpdateSubjectsCurriculumElements = (curriculumId, subjectIds = [], form = {}) =>
  request
    .put(`/assessment/${curriculumId}/subject/batch/curriculum-elements`, { subjectIds, ...form })
    .then((res) => res)

export const batchDeleteSubjects = (curriculumId, subjectIds = []) =>
  request.post(`/assessment/${curriculumId}/subject/batch/delete`, { subjectIds }).then((res) => res)
